import { Box, Text, theme } from "@bpba/ui-components";
import styled from "styled-components";
import React, { useEffect, useRef, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { BloqueoBipRequest } from "../../rest/models/BloqueoBipRequest";
import { useMutation } from "@apollo/client";
import { Mutations } from "../../rest/Mutations";
import { postBloqueoBip } from "../../rest/mutations/postBloqueoBip";
import { SpinnerCajas } from "../../pages/Spinner/SpinnerCajas";
import { FormOTP } from "./FormOTP";

type FormProps = {
  callback: (info: [string, string]) => void;
};

export const Form = (props: FormProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [username, setUsername] = useState<string>("");

  const { executeRecaptcha } = useGoogleReCaptcha();

  const focusOn = useRef<HTMLInputElement | null>(null);

  const [post] = useMutation<Mutations>(postBloqueoBip);

  useEffect(() => {
    focusOn.current?.scrollIntoView(false);
    focusOn.current?.focus();
  }, []);

  const otpCallback = (otp: string) => {
    onsubmit(otp);
  };

  const onsubmit = async (otp: string) => {
    focusOn.current?.scrollIntoView(false);
    setLoading(true);
    const token = executeRecaptcha && (await executeRecaptcha("BloqueoBip"));

    const requestData: BloqueoBipRequest = new BloqueoBipRequest();
    requestData.username = username;
    requestData.otp = otp;
    requestData.token = token!;

    await post({ variables: { input: requestData } })
      .then((response: any) => {
        props.callback([
          "Usuario deshabilitado",
          infoMsg(
            requestData.username,
            response.data.BloqueoBipResponse.transactionId
          ),
        ]);
      })
      .catch((error: any) => {
        error.networkError?.result.StatusCode === 409
          ? props.callback([
              "Error",
              errorMsg(
                error.networkError?.result?.Message,
                error.networkError?.result?.TransactionId
              ),
            ])
          : props.callback([
              "Error",
              "Ha ocurrido un error inesperado, aguardá unos minutos y volvé a intentarlo.",
            ]);
      });
  };

  return loading ? (
    <Box mb={"100px"} mt={"148px"}>
      <SpinnerCajas />
    </Box>
  ) : (
    <Box flexDirection={"column"}>
      <Text
        fontSize={"1.5rem"}
        lineHeight={"1.8rem"}
        color={theme.colors.primary[0]}
        fontWeight={600}
      >
        Deshabilitar usuario BIP
      </Text>
      <Text>
        Este formulario deshabilita tu usuario del Home Banking y tiene efecto
        inmediato. Por favor, completá los campos solo si estás seguro de querer
        deshabilitarlo.
      </Text>
      <Text>
        Este proceso NO se puede cancelar por medio de la web. Para rehabilitar
        tu usuario debés presentarte personalmente con tu DNI en cualquier
        sucursal.
      </Text>
      <StyledInput
        ref={focusOn}
        placeholder="Ingresá tu usuario de BIP"
        value={username}
        onChange={(e) => {
          setUsername(e.target.value);
        }}
      />
      {username.length > 3 && <FormOTP otpCallback={otpCallback} />}
    </Box>
  );
};

const StyledInput = styled.input({
  fontSize: "1rem",
  marginTop: "24px",
  lineHeight: "1.7rem",
  padding: "12px !important",
  width: "100%",
  height: "100% !important",
  color: "#3c3c3b !important",
  backgroundColor: "#ebebeb",
  border: "none",
  borderRadius: "0px",
  borderBottom: "1px solid black",
});

const infoMsg = (username: string, cod: string) => {
  return `Tu usuario <b>${username}</b> ha sido deshabilitado. Ya no podrás ingresar al Home Banking. Para reactivarlo acercate a cualquier sucursal con tu DNI.<br><br>Código de gestión: <b>${cod}</b>`;
};

const errorMsg = (msg: string, cod: string) => {
  return `${msg}<br><br> Código de gestión: <b>${cod}</b>`;
};
